import { useIntl } from 'react-intl';
import { Divider, Form, notification } from 'antd';
import { useHistory } from 'react-router';

import SuppliersGeneralInfoForm from '@/components/Suppliers/SuppliersGeneralInfoForm';
import TabContentWrapper from '@/components/_common/TabContentWrapper';
import { SaveButton } from '@/components/_common/Buttons';
import { PageProps } from '@/types/PageProps';
import { Supplier } from '@/core/domain/people/Suppliers/Suppliers.types';
import { useCreateSupplier } from '@/core/domain/people/Suppliers/Suppliers.hooks';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import ButtonBack from '@/components/_common/ButtonBack';

function SuppliersCreatePage({ route }: PageProps) {
  const intl = useIntl();
  const history = useHistory();

  const [form] = Form.useForm<Supplier>();

  const createSupplier = useCreateSupplier();

  const handleSaveClick = async () => {
    try {
      const values = await form.validateFields();

      const obj = {
        ...values,
        active: true,
      };

      const response = await createSupplier.mutateAsync(obj);

      history.push(`/app/registry/suppliers/${response.id}`);
    } catch (err) {
      notification.error({
        message: intl.formatMessage({
          id: 'commons.form.notification.error',
        }),
        description: intl.formatMessage({
          id: 'commons.form.notification.errorDescription',
        }),
      });
    }
  };

  return (
    <TabContentWrapper
      permissions={route.permissions}
      title={route.name}
      extra={
        <SaveButton
          onClick={handleSaveClick}
          disabled={createSupplier.isLoading}
          loading={createSupplier.isLoading}
        >
          {intl.formatMessage({ id: 'commons.form.button.save' })}
        </SaveButton>
      }
    >
      <SuppliersGeneralInfoForm form={form} />

      <Divider />

      <SpaceForButton>
        <ButtonBack path="/app/registry/suppliers" />
      </SpaceForButton>
    </TabContentWrapper>
  );
}

export default SuppliersCreatePage;
